import styled from "@yb/styled-px2rem";
import {Ellipsis} from "@FRAMEWORK/ui/mobile/text";

const Wrap = styled.div`
	width: 100%;
	padding: 0 15px;
	margin: 30px 0;
`;

const SubTitle = styled.h3`
	font-size: 18px;
	font-weight: bold;
	color: var(--emp-color);
`;

const LinkList = styled.ul`
	display: flex;
	flex-direction: column;
	width: 100%;
	margin-top: 15px;
	border: 1px solid var(--yellow-color);
`;

const LinkListItem = styled.li`
	+ li {
		border-top: 1px solid var(--yellow-color);
	}
`;

const Link = styled.a`
	display: flex;
	justify-content: space-between;
	padding: 15px;
`;

const LinkTitle = styled.p`
	${Ellipsis(1)};
`;

const LinkArrow = styled.span`
	display: flex;
	align-items: center;
	white-space: nowrap;
	margin-left: 10px;
	&::after {
		display: inline-block;
		width: 8px;
		height: 8px;
		margin-top: 2px;
		margin-left: 5px;
		border-top: 1px solid var(--default-color);
		border-left: 1px solid var(--default-color);
		transform: rotate(135deg);
		content: "";
	}
`;

export {Link, LinkArrow, LinkList, LinkListItem, LinkTitle, SubTitle, Wrap};
